import { schoolOrgTypes } from '../../../common/src/model.ts';
import { OrgChoice } from './onboarding/org_choice.tsx';

export interface Props {
  visible: boolean;
  onSettingChanged(): void;
  onBack(): void;
}

export const ChooseSchoolPage = ({ visible, onSettingChanged, onBack }: Props) =>
  !visible ? null : <OrgChoice onSettingChanged={onSettingChanged} onBack={onBack} orgTypes={schoolOrgTypes} />;
